import { render, staticRenderFns } from "./SelectDigiBoards.vue?vue&type=template&id=0b028714&scoped=true&"
import script from "./SelectDigiBoards.vue?vue&type=script&lang=js&"
export * from "./SelectDigiBoards.vue?vue&type=script&lang=js&"
import style0 from "./SelectDigiBoards.vue?vue&type=style&index=0&id=0b028714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b028714",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VCardActions,VSpacer})
